import { 
  UsersApiResponse,
  ServerConfig
} from '../types/player';
// import { USERS_API_AUTH_TOKEN } from '../config';

const USERS_API_BASE_URL = 'https://api.playcdu.co';

export class UsersApiService {
  private baseUrl: string;

  constructor(baseUrl: string = USERS_API_BASE_URL) {
    this.baseUrl = baseUrl;
  }

  async getPlayerStatsByUsername(username: string): Promise<UsersApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/users/username/?username=${username}`);
      
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error(`Player with username '${username}' not found.`);
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: UsersApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching player stats:', error);
      throw error;
    }
  }

  async getPlayerStatsByUuid(uuid: string): Promise<UsersApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/users/uuid/?uuid=${uuid}`);
      
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error(`Player with UUID '${uuid}' not found.`);
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: UsersApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching player stats by UUID:', error);
      throw error;
    }
  }

  async getPlayerStatsByDiscordId(discordId: string): Promise<UsersApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/users/discord/?discord=${discordId}`);
      
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error(`Player with Discord ID '${discordId}' not found.`);
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: UsersApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching player stats by Discord ID:', error);
      throw error;
    }
  }
}

export const usersApiService = new UsersApiService();

/**
 * Fetches the list of server configurations, including cluster names and logos.
 */
class ConfigService {
  private baseUrl = 'https://api.playcdu.co';
  private clusterApiUrl = 'https://api.playcdu.co';

  async getConfigs(): Promise<ServerConfig[]> {
    try {
      const response = await fetch(`${this.baseUrl}/configs`);
      if (!response.ok) {
        throw new Error('Failed to fetch server configs');
      }
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching server configs:', error);
      throw error;
    }
  }

  async getClusterFqdnMapping(): Promise<Record<string, string[]>> {
    try {
      // This is a direct call, so no proxy needed.
      const response = await fetch(`${this.clusterApiUrl}/cluster`);
      if (!response.ok) {
        throw new Error('Failed to fetch cluster FQDN mapping');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching cluster FQDN mapping:', error);
      throw error;
    }
  }
}

export const configService = new ConfigService();
